//noScroll
class MenuHover {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const HoverMenu = document.querySelector('.hovMenu');
    const MenuContent = document.querySelector('.menuContent');
    
    // お品書き
    // ===================================================
    HoverMenu.addEventListener('mouseover', () => {
      HoverMenu.classList.add("is-active")
      MenuContent.classList.add("is-active")
    }, false);
    HoverMenu.addEventListener('mouseleave', () => {
      MenuContent.classList.remove("is-active")
      HoverMenu.classList.remove("is-active")
    }, false);

    MenuContent.addEventListener('mouseover', () => {
      MenuContent.classList.add("is-active")
      HoverMenu.classList.add("is-active")
    }, false);
    MenuContent.addEventListener('mouseleave', () => {
      MenuContent.classList.remove("is-active")
      HoverMenu.classList.remove("is-active")
    }, false);
  }
}
